/**
 * Видеонаблюдение — копия legacy main_cameras.tpl + assets/js/cameras3.js.
 *
 * Разметка 1:1: модалки .modalvideo/.modalbarrier (в main.css они display:none,
 * блок-триггер .downloads_links в шаблоне закомментирован — оставляем как есть),
 * затем .row с плитками .cameraPrew col-lg-3 col-md-3 col-sm-4 col-xs-6:
 * превью print_screen_shot.php + <p class="cameraNameMP">.
 *
 * Legacy Main::cameras подключал:
 *   css: /assets/css/cameras.css, out_css: font-awesome 4.7 с CDN
 *   out_js: //cdn.airnet.ru/cctv/player/js/main.js (глобал airCam)
 *   js: cameras3.js — клик по .cameraPrew →
 *       airCam.showcam(cameras_list[k], {screenshot:true, archive:true}, cameras_list)
 */

import { useState } from 'react'

import type { Camera } from '@/api/types'
import { useCameraPlayer, useLegacyCss } from '@/lib/legacyAssets'
import { useApi } from '@/lib/useApi'

const FONT_AWESOME_CSS = 'https://cdn.airnet.ru/css/font-awesome/font-awesome-4.7.0/css/font-awesome.min.css'
const PREVIEW_URL = 'https://cdn.airnet.ru/airnet/player/stable/php/print_screen_shot.php'

interface AirCam {
  showcam: (
    camera: Camera,
    options: { screenshot: boolean; archive: boolean },
    list: Camera[],
  ) => void
}

declare global {
  interface Window {
    airCam?: AirCam
  }
}

export function CamerasPage() {
  useLegacyCss('cameras', FONT_AWESOME_CSS)
  // грузит и сам плеер, и его зависимость proeye.js (main.js в SPA сделать этого не может)
  const playerReady = useCameraPlayer()

  const { data } = useApi<Camera[]>('/api/content/cameras')
  const cameras = data ?? []

  // модалки закрываются крестиком (в legacy — onclick style.display='none')
  const [videoHidden, setVideoHidden] = useState(false)
  const [barrierHidden, setBarrierHidden] = useState(false)

  /** cameras3.js: new_player_init($(this)) по data-camera_k. */
  const showCamera = (index: number): void => {
    // пока плеер не догрузился, клик игнорируем — иначе падал ReferenceError: ProEye_Player
    if (!playerReady) return
    const camera = cameras[index]
    if (camera === undefined) return
    window.airCam?.showcam(camera, { screenshot: true, archive: true }, cameras)
  }

  return (
    <>
      <div
        className="modalvideo"
        id="modalvideo"
        style={videoHidden ? { display: 'none' } : undefined}
      >
        <div className="headermv">Приложение "Видеонаблюдение"</div>
        <div className="closemv" onClick={() => setVideoHidden(true)}>
          x
        </div>
        <div className="bodymv">
          <a
            target="_blank"
            rel="noreferrer"
            className="gp_video"
            href="https://play.google.com/store/apps/details?id=ru.airnet.cctv"
          >
            <div className="mvgp">
              <div className="mvgpimg" />
              <div className="mvgpdesc">GooglePlay</div>
            </div>
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            className="as_video"
            href="https://apps.apple.com/ru/app/%D1%81%D0%BF%D0%B1-%D0%B2%D0%B8%D0%B4%D0%B5%D0%BE%D0%BD%D0%B0%D0%B1%D0%BB%D1%8E%D0%B4%D0%B5%D0%BD%D0%B8%D0%B5/id1438009421"
          >
            <div className="mvas">
              <div className="mvasimg" />
              <div className="mvasdesc">AppStore</div>
            </div>
          </a>
        </div>
      </div>

      <div
        className="modalbarrier"
        id="modalbarrier"
        style={barrierHidden ? { display: 'none' } : undefined}
      >
        <div className="headermb">Приложение "Шлагбаум"</div>
        <div className="closemb" onClick={() => setBarrierHidden(true)}>
          x
        </div>
        <div className="bodymb">
          <a
            target="_blank"
            rel="noreferrer"
            className="gp_barrier"
            href="https://apps.apple.com/ru/app/%D0%BF%D0%B0%D1%81%D1%82%D0%BE%D1%80%D1%81%D0%BA%D0%BE%D0%B5-%D0%BE%D0%B7%D0%B5%D1%80%D0%BE-%D1%88%D0%BB%D0%B0%D0%B3%D0%B1%D0%B0%D1%83%D0%BC/id1498912329"
          >
            <div className="mbgp">
              <div className="mbgpimg" />
              <div className="mbgpdesc">GooglePlay</div>
            </div>
          </a>

          <a
            target="_blank"
            rel="noreferrer"
            className="as_barrier"
            href="https://play.google.com/store/apps/details?id=ru.airnet.gatewaypastorallake"
          >
            <div className="mbas">
              <div className="mbasimg" />
              <div className="mbasdesc">AppStore</div>
            </div>
          </a>
        </div>
      </div>

      <div className="row">
        <br />
        {cameras.map((camera, index) => (
          <div
            key={camera.id}
            className="cameraPrew col-lg-3 col-md-3 col-sm-4 col-xs-6"
            data-camera_k={index}
            onClick={() => showCamera(index)}
          >
            <img src={`${PREVIEW_URL}?id=${camera.id}&thumb&user_id=1`} />
            <p className="cameraNameMP">{camera.name}</p>
          </div>
        ))}
      </div>
    </>
  )
}
